import React from 'react'
import Link from 'gatsby-link'

import DirectoryList from '../components/directory-list'

const DirectoryPage = ({ data }) => (
	<div>
		<div className="container text-center">
			<h2>Directory Page</h2>
			<p>You are viewing the directory page.</p>
			<Link to="/">← Go back to the homepage</Link>
		</div>

		<div className="bg-light mt-5 pb-5">
			<div className="py-5">
				<div className="container">
					<div className="mb-5">
						<h2>Directory Page</h2>
						<p>
							We pull the latest posts from <code>Directory</code> content model
							using Strapi API
						</p>
					</div>
					<div className="row">
						{data.allStrapiDirectory.edges.map(d => (
							<DirectoryList
								apiSourceUrl={data.site.siteMetadata.apiSourceUrl}
								document={d}
							/>
						))}
					</div>
				</div>
			</div>
		</div>
	</div>
)

export default DirectoryPage

export const directoryQuery = graphql`
	query directoryQuery {
		site {
			siteMetadata {
				apiSourceUrl
			}
		}
		allStrapiDirectory {
			edges {
				node {
					id
					title
					free
					body
					zip_code
					city
					address
					phone_number
					email
					website_url
					published_date
					thumbnail {
						url
					}
					banner {
						url
					}
				}
			}
		}
	}
`



// WEBPACK FOOTER //
// ./src/pages/directory.js